import { __extends } from 'tslib';
import * as React from 'react';
import ReactDOM__default from 'react-dom';

var Interpolate = (function (_super) {
    __extends(Interpolate, _super);
    function Interpolate(props) {
        var _this = _super.call(this, props) || this;
        _this.updateContent = function () {
            var i = 0;
            _this.props.str.replace(/%\(\w+\)s/g, function (match) {
                var _a;
                i++;
                var selector = match.replace('%(', '').replace(')s', '');
                if (_this.props[selector]) {
                    var component = _this.props[selector];
                    var place = (_a = _this.parent.current) === null || _a === void 0 ? void 0 : _a.querySelector("[data-interpolate=\"" + _this.getId(selector, i) + "\"");
                    if (place && component) {
                        ReactDOM__default.render(component, place);
                    }
                }
            });
        };
        _this.getInnerHtml = function () {
            var i = 0;
            return _this.props.str
                .replace(/((?<beforeInsertion>[^\s]{0,})|(?<spaceBeforeInsertion>[\s]{1,}))(?<insertion>%\(\w+\)s)(?<afterInsertion>[^\s\u2013]{0,})/g, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _a = args[args.length - 1], beforeInsertion = _a.beforeInsertion, spaceBeforeInsertion = _a.spaceBeforeInsertion, insertion = _a.insertion, afterInsertion = _a.afterInsertion;
                i++;
                var selector = insertion.replace('%(', '').replace(')s', '');
                var id = _this.getId(selector, i);
                return "<span style=\"white-space: nowrap\">" + (beforeInsertion || '') + (spaceBeforeInsertion ? '&nbsp;' : '') + "<span style=\"display: inline-block\" data-interpolate=\"" + id + "\"></span>" + (afterInsertion || '') + "</span>";
            });
        };
        _this.parent = React.createRef();
        return _this;
    }
    Interpolate.prototype.getId = function (selector, index) {
        return "ipl-" + selector + "-" + index;
    };
    Interpolate.prototype.componentDidMount = function () {
        this.updateContent();
    };
    Interpolate.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.updateContent();
    };
    Interpolate.prototype.render = function () {
        return (React.createElement("span", { className: this.props.className || '', ref: this.parent, dangerouslySetInnerHTML: { __html: this.getInnerHtml() } }));
    };
    return Interpolate;
}(React.PureComponent));

export { Interpolate as default };
//# sourceMappingURL=Interpolate.js.map
